export default {
    powerBiEnabled() {
        return process.env.VUE_APP_FEATURE_POWER_BI === 'true';
    },
    newPluginAppearanceEnabled() {
        return process.env.VUE_APP_FEATURE_NEW_PLUGIN_APPEARANCE === 'true';
    },
};
